import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { flushActivity, recordActivity, startActivityCapture } from '@/lib/activity'

export function ActivityTracker() {
  const location = useLocation()

  useEffect(() => startActivityCapture(), [])

  useEffect(() => {
    recordActivity({
      kind: 'navigate',
      path: `${location.pathname}${location.search}`,
      label: location.pathname,
    })
    void flushActivity()
  }, [location.pathname, location.search])

  return null
}
